import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./utils/i18n";
import "./index.css";
import debug from "debug";

window.debug = debug;

ReactDOM.render(<App />, document.getElementById("root"));
